import React, { useState, useRef } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import html2canvas from "html2canvas";
import { MenuItem, Select } from "@mui/material";
import infoIcon from "../../../../assets/icons/info-icon.svg";
import "./subscription-growth-trend.scss";

const SubscriptionGrowthTrend = (props: any) => {
  const { subscriptionGrowthTrend, handleAddSubscriptionReports, enableExport } = props;
  const chartRef = useRef(null);
  const [fileFormat, setFileFormat] = useState<any>("pdf");

  const handleExport = async () => {
    try {
      if (!chartRef.current) return;
      const canvas = await html2canvas(chartRef.current);
      const base64Image = canvas.toDataURL("image/png");
      handleAddSubscriptionReports(
        { imageData: base64Image.split(",")[1] },
        { section: "subscription-growth-trend", format: fileFormat }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const dataMap = payload.reduce((acc: any, item: any) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: 10,
            borderRadius: 6,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <p>
            <strong>{label}</strong>
          </p>
          <p style={{ color: "green" }}>
            New Subscription :{" "}
            {`${dataMap["New Subscription"]} ( ${payload?.find((info: any) => info?.name === "New Subscription")?.payload?.newSubscriptionsPercent} )`}
          </p>
          <p style={{ color: "orange" }}>
            Cancellation :{" "}
            {`${dataMap["Cancellation"]} ( ${payload?.find((info: any) => info?.name === "Cancellation")?.payload?.cancellationsPercent} )`}
          </p>
          <p style={{ color: "blue" }}>
            Net Growth :{" "}
            {`${dataMap["Net Growth"]} ( ${payload?.find((info: any) => info?.name === "Net Growth")?.payload?.netGrowthPercent} )`}
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="subscription-report-growth-trend-card">
      <div className="subscription-report-growth-trend-card-header">
        <div className="subscription-report-growth-trend-card-header-title">
          Subscription Growth Trend
        </div>
        <div className="subscription-report-growth-trend-card-header-sub-title">
          <div className="subscription-report-growth-trend-card-header-sub-title-sub-icon">
            <img src={infoIcon} alt="icon" />
            <div className="subscription-report-growth-trend-card-header-sub-title-sub-icon-text">
              This chart reflects current year data only
            </div>
          </div>
          <div className="subscription-report-growth-trend-card-header-sub-title-buttons-dropdown">
            <Select
              value={fileFormat}
              onChange={(e) => setFileFormat(e.target.value)}
              size="small"
            >
              <MenuItem
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#2684FF",
                    color: "#fff",
                    borderRadius: "0px !important",
                    ":hover": {
                      backgroundColor: "#2684FF !important",
                    }
                  },
                }}
                value="pdf"
              >
                PDF
              </MenuItem>
              <MenuItem
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#2684FF",
                    color: "#fff",
                    borderRadius: "0px !important",
                    ":hover": {
                      backgroundColor: "#2684FF !important",
                    }
                  },
                }}
                value="csv"
              >
                CSV
              </MenuItem>
            </Select>
            <button
              className="subscription-report-growth-trend-card-header-sub-title-buttons-dropdown-button"
              onClick={handleExport}
              disabled={!enableExport}
            >
              Export
            </button>
          </div>
        </div>
      </div>
      <div
        className="subscription-report-growth-trend-card-chart"
        ref={chartRef}
      >
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={subscriptionGrowthTrend}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis
              label={{
                value: "Conversion Rate in (%)",
                angle: -90,
                position: "insideLeft",
              }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Line
              type="monotone"
              dataKey="newSubscriptionsCount"
              stroke="#014421"
              legendType="circle"
              strokeWidth={2}
              name="New Subscription"
            />
            <Line
              type="monotone"
              dataKey="cancellationsCount"
              stroke="#FDBA74"
              legendType="circle"
              strokeWidth={2}
              name="Cancellation"
            />
            <Line
              type="basis"
              dataKey="netGrowthCount"
              stroke="#2563EB"
              legendType="circle"
              name="Net Growth"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SubscriptionGrowthTrend;
